import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import LayoutRoutes from "./LayoutRoutes";
import PublicRoute from "./PublicRoutes";
import { publicRoutes } from "./Route";

const RouterData = () => {
  const token = localStorage.getItem("Apptoken"); // Fix: Using correct key

  return (
    <BrowserRouter basename="/">
      <Routes>
        {/* Redirect logged-in users away from login */}
        {token && (
          <Route
            path="/login"
            element={<Navigate to="/dashboard/default" replace />}
          />
        )}

        {/* Redirect logged-in users away from public pages like login/forgotPassword */}
        <Route element={<PublicRoute />}>
          {publicRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={Component} />
          ))}
        </Route>

        {/* Private Routes (Require Authentication) */}
        <Route element={<PrivateRoute />}>
          <Route path="/*" element={<LayoutRoutes />} />
        </Route>

        {/* Default Route Redirect */}
        <Route
          path="/"
          element={<Navigate to="/dashboard/default" replace />}
        />

        {/* Catch-all route (404 Not Found) */}
        <Route
          path="*"
          element={<Navigate to="/dashboard/default" replace />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterData;
